import React from 'react';
import {
    getMembershipLifecycleNoticeMessage,
    MembershipLifecycle,
} from '../../lib/membershipLifecycle';

type Props = {
    lifecycle: MembershipLifecycle;
    /** 인계로 이어진 현재 수강권으로 이동. currentMembershipId 가 있을 때만 넘어온다. */
    onClickCurrentMembership?: () => void;
};

/**
 * 종료(소프트 삭제)된 수강권 상세 상단 배너.
 *
 * 이 화면은 지금까지 404 였다. 열리는 순간 관리자는 "왜 이 수강권이 이상한가"를 먼저 묻게
 * 되므로, 종료 사유와 **여기서 무엇이 되는지**를 한 줄로 말한다. 인계라면 갈 곳까지 잇는다.
 *
 * 탈퇴 배너(WithdrawnMemberReadOnlyNotice)와 같은 자리·같은 톤을 쓰되 색으로 구분한다 —
 * 탈퇴는 "전면 조회 전용"(주황), 종료는 "정정은 가능"(회색)이라 성격이 다르다.
 */
const MembershipLifecycleNotice = ({ lifecycle, onClickCurrentMembership }: Props) => {
    if (!lifecycle.isEnded) return null;

    return (
        <div
            role="status"
            className="flex w-full flex-row items-center justify-between gap-[16px] rounded-[12px] border border-solid border-[#CBD5E1] bg-[#F8FAFC] px-[18px] py-[14px]"
        >
            <span className="text-[14px] font-semibold leading-[1.5] text-[#334155]">
                {getMembershipLifecycleNoticeMessage(lifecycle)}
            </span>
            {onClickCurrentMembership && (
                <button
                    type="button"
                    onClick={onClickCurrentMembership}
                    className="h-[36px] shrink-0 rounded-[8px] border border-solid border-[#CBD5E1] bg-white px-[14px] text-[13px] font-bold text-[#334155] hover:bg-[#F1F5F9]"
                >
                    현재 수강권 보기
                </button>
            )}
        </div>
    );
};

export default MembershipLifecycleNotice;
